import { IoFilterSharp } from 'react-icons/io5';

export default function Filterbtn({ toggleFilters, showFilters }) {
    return (
        <button className="filter_btn" onClick={toggleFilters}>
            <IoFilterSharp />
            {showFilters ? "Close" : "Filter"}
        </button>
    );
}
